import { MapUtils } from '../../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
} from '../../../../dto/data-model.js';
import { EventTicketOrder } from '../../../event-ticket-order.js';
import { AuditLogEntryType } from '../../audit-log-entry-type.js';
import { AuditLogEntry } from '../../audit-log-entry.js';

export class SeatedOfflineEventTicketSwapEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'a99eecd314c1e4e529c35a1fc878022e3';

  private constructor(
    public readonly ticketId: string,
    public readonly oldSeatId: number,
    public readonly newSeatId: number,
    public readonly before: EventTicketOrder,
    public readonly after: EventTicketOrder,
  ) {
    super();
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.SeatedOfflineEventTicketSwap;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      eventId: this.after.eventId,
      orderId: this.after.uniqueId,
      ticketId: this.ticketId,
    };
  }

  get $typeId(): string {
    return SeatedOfflineEventTicketSwapEntry.TYPE_ID;
  }

  static create(args: {
    ticketId: string,
    oldSeatId: number,
    newSeatId: number,
    before: EventTicketOrder,
    after: EventTicketOrder,
  }): SeatedOfflineEventTicketSwapEntry {
    return new SeatedOfflineEventTicketSwapEntry(
        args.ticketId,
        args.oldSeatId,
        args.newSeatId,
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatedOfflineEventTicketSwapEntry {
    return this.create({
      ticketId: MapUtils.getString(map, 'ticketId'),
      oldSeatId: MapUtils.getNumber(map, 'oldSeatId'),
      newSeatId: MapUtils.getNumber(map, 'newSeatId'),
      before: context.fromData<EventTicketOrder>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<EventTicketOrder>(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      ticketId: this.ticketId,
      oldSeatId: this.oldSeatId,
      newSeatId: this.newSeatId,
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return SeatedOfflineEventTicketSwapEntry.create({
      ticketId: this.ticketId,
      oldSeatId: this.oldSeatId,
      newSeatId: this.newSeatId,
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.ticketId === this.ticketId &&
          other.oldSeatId === this.oldSeatId &&
          other.newSeatId === this.newSeatId &&
          isSameData(other.before, this.before) &&
          isSameData(other.after, this.after);
  }
}

export class SeatedOfflineEventTicketSwapEntryBuilder extends DataModelBuilder<SeatedOfflineEventTicketSwapEntry> {
  build(context: SerializationContext, map: SerializedData): SeatedOfflineEventTicketSwapEntry {
    return SeatedOfflineEventTicketSwapEntry.fromMap(context, map);
  }
}
